<template>
  <el-container id="app" :class="'layout-'+layout" style="flex-wrap:wrap;">
    <template v-if="layout==='blank'">
      <router-view :key="$route.path"/>
    </template>
    <template v-else>
      <el-header>
        <img src="./assets/logo.full.png" style="height: 40px;float:left"/>
          <div style="float:right">
          <el-badge :value="numOfUnhandledOrders">
              <el-button type="text" size="mini" @click="navToOrder">未处理订单</el-button>
          </el-badge>
          <el-divider direction="vertical"></el-divider>
          <el-badge :value="numOfUnhandledApplications">
            <el-button type="text" size="mini" @click="navToApplication">未处理申请</el-button>
          </el-badge>
          <el-divider direction="vertical"></el-divider>
          <el-dropdown @command="handleUserCommand" v-if="getCurrentUser()">
            <el-badge is-dot class="item" :hidden="getCurrentUser()._email_verified">
              <span class="el-dropdown-link">
                <i class="el-icon-user text-sm"> {{getCurrentUser().name||getCurrentUser()._username||getCurrentUser().nickname}}</i>
                <span v-if="isAdmin" class="text-danger"> • Admin</span>
                <i class="el-icon-arrow-down el-icon--right"/>
              </span>
            </el-badge>
            <el-dropdown-menu slot="dropdown" style="width:300px">
              <el-dropdown-item command="changePass" icon="el-icon-key">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout" icon="el-icon-lock">注销</el-dropdown-item>
              <el-dropdown-item divided icon="el-icon-mobile">{{getCurrentUser()._phone}}</el-dropdown-item>
              <el-dropdown-item divided icon="el-icon-message">
                <el-badge value="未验证" :hidden="getCurrentUser()._email_verified">{{getCurrentUser()._email}}</el-badge>
              </el-dropdown-item>
              <el-dropdown-item
                      :hidden="getCurrentUser()._email_verified"
                      icon="el-icon-coordinate"
                      command="verifyEmail"
              >去验证邮箱
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-container>
        <el-aside width="190px">
          <side-navbar :current="currentPath" />
          <div class="appendix">
            <el-divider><i class="el-icon-help"/></el-divider>
            <div class="text-xs text-sub text-bold" style="margin-bottom:10px">
              技术支持
            </div>
            <div class="text-xs text-sub">四川饺子互动科技有限公司</div>
            <div class="text-xs text-sub">support@devpal.pro</div>
            <el-popover placement="right" trigger="hover">
              <img src="@/assets/vicky_eqrcode.png" style="width:340px"/>
              <img slot="reference" src="@/assets/vicky_eqrcode_lite.jpg"/>
            </el-popover>
            <div class="text-muted text-xs">Version: 2.0.0</div>
          </div>
        </el-aside>
        <el-main>
          <transition name="fade">
            <router-view :key="$route.path"/>
          </transition>
        </el-main>
      </el-container>
      <!--修改密码 -->
      <el-dialog title="修改密码" :visible.sync="passDialogFormVisible" width="400px">
        <el-form :model="pass" :rules="passRules" ref="passForm">
          <el-form-item label="当前密码" prop="old">
            <el-input v-model="pass.old" autocomplete="off" type="password"/>
          </el-form-item>
          <el-form-item label="新密码" prop="new">
            <el-input v-model="pass.new" autocomplete="off" type="password"/>
          </el-form-item>
          <el-form-item label="重复新密码" prop="check">
            <el-input v-model="pass.check" autocomplete="off" type="password"/>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="passDialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="changePass">确 定</el-button>
        </div>
      </el-dialog>
    </template>
  </el-container>
</template>

<script>
import SideNavbar from "./SideNavbar";

const DEFAULT_LAYOUT = "basic";

export default {
    components: {
        SideNavbar
    },
    data: function () {
        let validateCheckNewPass = (rule, value, callback) => {
            if (value === this.pass.old) {
                callback(new Error("新密码不允许与旧密码一致!"));
            } else {
                callback();
            }
        };
        let validateCheckPass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.pass.new) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            passDialogFormVisible: false,
            pass: {
                old: "",
                new: "",
                check: ""
            },
            passRules: {
                old: [
                    {
                        required: true,
                        message: "密码不能为空",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        max: 15,
                        message: "长度在 6 到 15 个字符",
                        trigger: "blur"
                    }
                ],
                new: [
                    {
                        required: true,
                        message: "密码不能为空",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        max: 15,
                        message: "长度在 6 到 15 个字符",
                        trigger: "blur"
                    },
                    {validator: validateCheckNewPass, trigger: "blur"}
                ],
                check: [{validator: validateCheckPass, trigger: "blur"}]
            },
            numOfUnhandledOrders: 0,
            numOfUnhandledApplications:0,
        }
    },
    computed: {
        layout() {
            return this.$route.meta
                ? this.$route.meta.layout || DEFAULT_LAYOUT
                : DEFAULT_LAYOUT;
        },
        pageName() {
            return this.$route.name;
        },
        currentPath(){
            return this.$route.path;
        }
    },
    created() {
        this.$router.beforeEach((to, from, next) => {
            let path = to.fullPath;
            if (
                path === "/login" ||
                path === "/register" ||
                path === "/401" ||
                path === "/403" ||
                path === "/404"
            ) {
                next();
            } else {
                let user = this.getCurrentUser();
                if (user) {
                    if (user.is_admin === 1) {
                        if (to.meta && to.meta.saOnly) {
                            if (user.is_sa) {
                                next();
                            } else {
                                next('/403');
                            }
                        } else {
                            next();
                        }
                    } else {
                        next("/401");
                    }
                } else {
                    next("/login");
                }
            }
        });
    },
    mounted() {
        if (['/login', '/register', '/401', '/403', '/404'].includes(this.$route.fullPath)) {
            return;
        }
        if (!this.getCurrentUser()) {
            this.$router.replace("/login");
        }
        this.fetchNumOfUnhandledOrders();
        this.$ox.eventBus.$on('order-handled', ()=>{
          this.fetchNumOfUnhandledOrders();
        })
        this.fetchNumOfUnhandledApplications();
        this.$ox.eventBus.$on('application-handled',()=>{
          this.fetchNumOfUnhandledApplications();
        })
    },
    methods: {
        logout() {
            window.BaaS.auth.logout().then(() => {
                this.$ox.session.clear();
                this.$router.replace("/login");
            });
        },
        openPassChangeDialog() {
            this.pass = {
                old: "",
                new: "",
                check: ""
            };
            this.passDialogFormVisible = true;
        },
        verifyEmail() {
            window.BaaS.auth.getCurrentUser().then(user => {
                user.requestEmailVerification()
                    .then(() => {
                        this.$alert(
                            "验证邮件已发送至你的邮箱，请在 10 分钟内查收邮件并完成验证",
                            "操作成功",
                            {
                                confirmButtonText: "确定"
                            }
                        );
                    })
                    .catch(err => {
                        this.$message.error(err.data.error_msg);
                    });
            });
        },
        handleUserCommand(command) {
            switch (command) {
                case "changePass": {
                    this.openPassChangeDialog();
                    break;
                }
                case "logout":
                    this.logout();
                    break;
                case "verifyEmail":
                    this.verifyEmail();
                    break;
                case undefined:
                    break;
                default:
                    this.$message("功能暂未实现");
                    break;
            }
        },
        changePass() {
            this.$refs["passForm"].validate(valid => {
                if (valid) {
                    window.BaaS.auth.getCurrentUser().then(user => {
                        user.updatePassword({
                            password: this.pass.old,
                            newPassword: this.pass.new
                        })
                            .then(() => {
                                this.passDialogFormVisible = false;
                                this.$alert(
                                    "你的密码已修改，请点击确定后重新登录系统",
                                    "操作成功",
                                    {
                                        confirmButtonText: "确定",
                                        callback: () => {
                                            this.logout();
                                        }
                                    }
                                );
                            })
                            .catch(err => {
                                this.$message.error(err.data.error_msg);
                            });
                    });
                } else {
                    this.$message.warning("密码填写有误");
                    return false;
                }
            });
        },
        fetchNumOfUnhandledOrders(){
          const query = new window.BaaS.Query();
          query.compare('state', '=', 1);
          this.$ox.service('order').count(query).then(count=>{
            this.numOfUnhandledOrders = count;
          })
        },
        fetchNumOfUnhandledApplications(){
          const query = new window.BaaS.Query();
          query.compare('is_handled', '!=', true);
          this.$ox.service('demand_application').count(query).then(count=>{
            this.numOfUnhandledApplications = count;
          })
        },
        navToOrder(){
          this.$router.push("/order");
        },
        navToApplication(){
          this.$router.push('/demand/application')
        }
    }
}
</script>

<style>
@font-face{
    font-family: 'BebasNeue';
    src: url("https://cloud-minapp-32403.cloud.ifanrusercontent.com/BebasNeue Regular.ttf")
}
body {
  margin: 0;
  font-family: PingFang SC, Lantinghei SC, Helvetica Neue, Helvetica, Arial,
  Microsoft YaHei, "\5FAE\8F6F\96C5\9ED1", STHeitiSC-Light, simsun,
  "\5B8B\4F53", WenQuanYi Zen Hei, WenQuanYi Micro Hei, "sans-serif";
  font-size: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.padded {
  padding: 15px;
}

.page-header {
  padding-top:10px;
  padding-left:10px;
  background: #fff;
}

.more-tools {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.tools .divider, .more-tools .divider {
  width: 1px;
  height: 30px;
  margin: 0 15px;
  overflow: hidden;
  border-right: 1px solid #eee;
  display: inline-block;
}

.block {
  display: block;
}

.row-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  vertical-align: middle;
}

.padded {
  padding: 15px;
}

.text-primary {
  color: #303132;
}

.text-secondary {
  color: #606266;
}

.text-sub {
  color: #909398;
}

.text-muted {
  color: #c0c4cc;
}

.text-danger {
  color: #F56C6C;
}

.text-success {
  color: #4ac705;
}

.text-bold {
  font-weight: 500 !important;
}
.number{
  font-family: monospace;
  font-weight: 300;
}
.h1 {
  font-size: 20px;
  font-weight: normal;
}

.h2 {
  font-size: 18px;
  font-weight: normal;
}

.h3 {
  font-size: 16px;
  font-weight: normal;
}

.text {
  font-size: 14px;
}

.text-sm {
  font-size: 13px;
}

.text-xs {
  font-size: 12px;
}
.fluid img{
  width:100%;
}
.number{
  font-family:BebasNeue;
}
.btns{
  display:flex;
  justify-content: space-evenly;
  align-items: center;
}
/** workspace **/
.workspace{
  margin:15px;
}
.ws-unit {
  border-radius: 6px;
  background-color: #fff;
  box-shadow:0 0 8px 0 #c5d9e8;
}


.ws-unit-header {
  padding: 0 15px;
  height: 60px;
  border-bottom: 1px solid #e4e7ec;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ws-unit-title {
  flex-shrink: 0;
}

.ws-unit-toolbar {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.ws-unit-toolbar .el-form--inline {
  margin-right: -10px;
}

.ws-unit-toolbar .el-form-item,
.ws-unit-second-toolbar .el-form-item {
  margin-bottom: 0;
}
.ws-unit-toolbar .el-form-item__content{
  line-height: 100%;
}

.ws-unit-toolbar .el-form-item__content .el-input-group {
  vertical-align: middle !important;
}

.ws-unit-second-toolbar {
  padding: 15px 15px 0 15px;
}

.ws-unit-body {
  padding: 0 15px;
}

.ws-unit-footer {
  padding: 15px;
}

label {
  color: #99a9bf;
}

/** table**/
.expand-column {
  line-height: 200%;
  font-size:12px;
}

.expand-column label {
  width: 80px;
  display: inline-block;
}
.pagination{
  padding:15px 0;
  background:#fff;
}

/** override v-region **/
div.rg-select div.rg-select__el div.rg-select__content{
  padding:0 30px 0 15px!important;
}
.rg-default-btn{
  padding:4px 12px!important;
}
</style>

<style scoped>
.el-aside {
  background-color: #fff;
  text-align: center;
  line-height: 180%;
  position: relative;
  padding: 15px;
  box-shadow:0 0 8px 0 #c5d9e8;
  height: 95vh;
  overflow-y: auto;
  z-index:0;
}

.el-main {
  background-color: #f5f6fd;
  color: #333;
  line-height: 160%;
  height: 95vh;
  padding: 0;
}

.logo img {
  width: 60%;
  padding: 15px 0 0 0;
}

.layout-blank {
  font-size: 12px;
  background: #f7f7f7;
  text-align: center;
}

.el-aside .appendix {
  margin-top:50px;
  line-height: 120%;
}

.el-aside .appendix img {
  width: 120px;
  margin-top: 10px;
}

.el-header {
  padding: 15px;
  background: #fff;
  box-shadow:0 0 8px 0 #c5d9e8;
  z-index: 1;
  clear:both;
  width:100%;
}

</style>
